import { Row, Col } from 'reactstrap';
import { PageHeader } from '../../components/PageHeader';
import { DataTable } from '../../components/DataTable';
import { KpiCard } from '../../components/KpiCard';
import { useDeployStats } from './useDeployStats';

/**
 * Produkt-Statistik Deploy/Sites — Betreiber-Sicht, nur lesend. KPI-Kacheln oben,
 * darunter die Aufschlüsselung der Deploys nach Status (30 Tage).
 */
const fmt = new Intl.NumberFormat('de-DE');

export function NexusDeployStatsPage() {
  const stats = useDeployStats();
  const data = stats.data ?? {};
  const deploys = data.deploys ?? {};
  const byStatus = data.byStatus ?? [];
  const successRate = data.successRate == null ? '—' : `${(data.successRate * 100).toFixed(1)} %`;

  return (
    <div>
      <PageHeader title="Deploy/Sites" subtitle="Produkt-Statistik — Sites, Deploys und Erfolgsquote" />

      <Row className="g-3 mb-3">
        <Col xs="6" md="4" lg="2"><KpiCard label="Sites" value={fmt.format(data.sites ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="Tenants" value={fmt.format(data.tenants ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="Deploys gesamt" value={fmt.format(deploys.total ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="Erfolge" value={fmt.format(deploys.success ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="Fehler" value={fmt.format(deploys.failed ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="Erfolgsquote" value={successRate} /></Col>
      </Row>

      <Row className="g-3">
        <Col xs={12} lg={6}>
          <div className="text-muted small text-uppercase mb-2">Deploys nach Status (30 Tage)</div>
          <DataTable
            loading={stats.isLoading}
            error={stats.error}
            empty={!stats.isLoading && byStatus.length === 0}
            emptyMessage="Keine Deploys im Zeitraum."
            onRetry={() => stats.refetch()}
          >
            <thead>
              <tr>
                <th>Status</th>
                <th className="text-end">Deploys</th>
              </tr>
            </thead>
            <tbody>
              {byStatus.map((r) => (
                <tr key={r.status}>
                  <td className="small">{r.status}</td>
                  <td className="text-end small">{fmt.format(r.n ?? 0)}</td>
                </tr>
              ))}
            </tbody>
          </DataTable>
        </Col>
      </Row>
    </div>
  );
}
